var CommentCtrl = function (gettextCatalog, Feedback, Notification) {
    this._Feedback = Feedback;
    this._Notification = Notification;
    this.gettextCatalog = gettextCatalog;
    this.model = {
      goodScooter: '',
      badScooter: '',
      perfectScooter: '',
      declineReason: '',
      buyingReason: '',
      equipment: '',
      complaints: ''
    };
};

CommentCtrl.prototype.send = function () {
    var self = this;
    
    this._Feedback.create(
        this.model,
        function () {
            self._Notification.success(self.gettextCatalog.getString('Feedback eingereicht'));
        }, function () {
            self._Notification.error(self.gettextCatalog.getString('Feedback konnte nicht eingereicht werden'));
        });
};

module.exports = CommentCtrl;



// WEBPACK FOOTER //
// ./client/src/app/modules/comment/CommentCtrl.js